// extracted by mini-css-extract-plugin
export default {"archive-you-sure":"styles_archive-you-sure__JJ0kz","no":"styles_no__9IeNp"};